"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The annual income of the applicant
 * @export
 * @enum {string}
 */
var Income;
(function (Income) {
    Income["_025000"] = "0-25000";
    Income["_2500150000"] = "25001-50000";
    Income["_50001100000"] = "50001-100000";
    Income["_100001200000"] = "100001-200000";
    Income["_200001300000"] = "200001-300000";
    Income["_300001500000"] = "300001-500000";
    Income["_5000011200000"] = "500001-1200000";
    Income["_12000019999999"] = "1200001-9999999";
})(Income = exports.Income || (exports.Income = {}));
function IncomeFromJSON(json) {
    return IncomeFromJSONTyped(json, false);
}
exports.IncomeFromJSON = IncomeFromJSON;
function IncomeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.IncomeFromJSONTyped = IncomeFromJSONTyped;
function IncomeToJSON(value) {
    return value;
}
exports.IncomeToJSON = IncomeToJSON;
